import { Controller } from "stimulus"

export default class extends Controller {
  findScrollableAncestor(element) {
    while (element && element !== document.body) {
      const style = getComputedStyle(element)
      const overflowY = style.overflowY
      const isScrollable = (overflowY === 'auto' || overflowY === 'scroll') && element.scrollHeight > element.clientHeight
      if (isScrollable) {
        return element
      }
      element = element.parentElement
    }
    return null
  }

  getScrollContainer() {
    const scrollable = this.findScrollableAncestor(this.element)
    if (scrollable) return scrollable

    return document.documentElement.scrollTop ? document.documentElement : document.body
  }

  saveScrollPosition() {
    const container = this.getScrollContainer()
    this.savedScrollX = container.scrollLeft || window.scrollX
    this.savedScrollY = container.scrollTop || window.scrollY
  }

  reload(event) {
    this.saveScrollPosition()

    // Get the form element
    const form = this.element.closest('form')
    if (!form) return

    // Find the turbo-frame using the configured frame id from data attribute
    const frameId = this.data.get('frame-id')
    if (!frameId) return

    const frame = document.getElementById(frameId)
    if (!frame) return

    // Collect form data
    const formData = new FormData(form)
    const params = new URLSearchParams()

    // Convert form data to URL params
    for (const [key, value] of formData.entries()) {
      // Skip empty values and authenticity token
      if (value !== '' && key !== 'authenticity_token') {
        params.append(key, value)
      }
    }

    const scrollX = this.savedScrollX || 0
    const scrollY = this.savedScrollY || 0

    // Restore scroll position after frame loads
    const handleFrameLoad = (event) => {
      if (event.target.id === frameId) {
        // Re-find the scroll container since it may have been replaced by Turbo
        const freshContainer = this.getScrollContainer()
        freshContainer.scrollTo(scrollX, scrollY)
        document.removeEventListener('turbo:frame-load', handleFrameLoad)
      }
    }
    document.addEventListener('turbo:frame-load', handleFrameLoad)

    // Navigate the turbo-frame to the new URL with params
    frame.src = `${window.location.pathname}?${params.toString()}`
  }
}